import { useMutateGetFile } from "@/api/s3.api";

const openDocumentUrl = (url: string) => {
  const isIOSSafari =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent);

  if (isIOSSafari) {
    window.location.href = url;
    return;
  }

  try {
    const newWindow = window.open(url, "_blank");
    if (!newWindow) {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
};

export const useDisplayDocument = () => {
  const { mutateAsync: getFile } = useMutateGetFile();

  const displayDocument = async (source: string | File) => {
    try {
      const url = source instanceof File ? URL.createObjectURL(source) : await getFile(source);
      openDocumentUrl(url);
    } catch (error) {
      console.error("Failed to open document:", error);
    }
  };

  return { displayDocument };
};
